import { EmptyCart } from '@/entities/cart-page/EmptyCart/ui/EmptyCart'
import './ui/EmptyCart.scss'
export default EmptyCart
